import React, { useEffect, useRef } from 'react';
import { FiTrash2 } from 'react-icons/fi';
import styles from './projectWorkspace.module.scss';

export const RemoveCandidatesDialog = ({ count, onCancel, onConfirm }) => {
  const dialog = useRef(null);
  useEffect(() => {
    const previousFocus = document.activeElement;
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    dialog.current.querySelector('button').focus();
    return () => {
      document.body.style.overflow = previousOverflow;
      previousFocus?.focus();
    };
  }, []);
  const handleKey = (event) => {
    if (event.key === 'Escape') onCancel();
    if (event.key === 'Tab') {
      const buttons = dialog.current.querySelectorAll('button');
      if (event.shiftKey && document.activeElement === buttons[0]) {
        event.preventDefault();
        buttons[buttons.length - 1].focus();
      } else if (!event.shiftKey && document.activeElement === buttons[buttons.length - 1]) {
        event.preventDefault();
        buttons[0].focus();
      }
    }
  };
  return (
    <div className={styles.dialogBackdrop}>
      <div
        ref={dialog}
        className={styles.dialog}
        role="dialog"
        aria-modal="true"
        aria-labelledby="remove-candidates-title"
        aria-describedby="remove-candidates-description"
        onKeyDown={handleKey}
      >
        <span className={styles.dialogIcon}>
          <FiTrash2 />
        </span>
        <h2 id="remove-candidates-title">
          Remove {count === 1 ? 'this candidate' : `these ${count} candidates`}?
        </h2>
        <p id="remove-candidates-description">
          This permanently removes {count === 1 ? 'them' : 'these candidates'} from this project.
          Their Holedo profiles stay intact. This action can’t be undone.
        </p>
        <div>
          <button type="button" className={styles.secondaryButton} onClick={onCancel}>
            Keep in bin
          </button>
          <button type="button" className={styles.removeButton} onClick={onConfirm}>
            Remove {count === 1 ? 'candidate' : 'candidates'}
          </button>
        </div>
      </div>
    </div>
  );
};
